import { useState } from 'react';

export default function MaterialsTab() {
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('all');

  const materials = [
    { id: 1, name: '石材パケット_大理石_001', category: '石材', size: '245 MB', date: '2025-01-15', status: 'active', models: 12 },
    { id: 2, name: 'タイル素材_セラミック_A', category: 'タイル', size: '189 MB', date: '2025-01-14', status: 'active', models: 8 },
    { id: 3, name: '木材テクスチャ_オーク', category: '木材', size: '312 MB', date: '2025-01-13', status: 'active', models: 15 },
    { id: 4, name: '金属素材_ステンレス', category: '金属', size: '156 MB', date: '2025-01-12', status: 'processing', models: 6 },
    { id: 5, name: 'ガラス材質_透明', category: 'ガラス', size: '98 MB', date: '2025-01-11', status: 'active', models: 4 },
    { id: 6, name: 'コンクリート_打放し', category: 'コンクリート', size: '278 MB', date: '2025-01-10', status: 'active', models: 10 },
    { id: 7, name: '壁紙素材_和紙風', category: '壁紙', size: '134 MB', date: '2025-01-09', status: 'active', models: 7 },
    { id: 8, name: 'カーペット_ウール', category: 'カーペット', size: '201 MB', date: '2025-01-08', status: 'active', models: 9 },
  ];

  const categories = ['all', '石材', 'タイル', '木材', '金属', 'ガラス', 'コンクリート', '壁紙', 'カーペット'];

  const filteredMaterials = selectedCategory === 'all' 
    ? materials 
    : materials.filter(m => m.category === selectedCategory);

  return (
    <div className="p-8">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2">材料データ管理</h2>
          <p className="text-gray-600">3D素材パケットとテクスチャの管理</p>
        </div>
        <button
          onClick={() => setShowUploadModal(true)}
          className="px-6 py-3 bg-teal-500 text-white rounded-lg font-medium hover:bg-teal-600 transition-colors flex items-center gap-2 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-upload-cloud-line text-lg"></i>
          新規アップロード
        </button>
      </div>

      <div className="bg-white rounded-xl border border-gray-200/80 mb-6">
        <div className="p-6 border-b border-gray-200/80">
          <div className="flex items-center gap-4 flex-wrap">
            <div className="relative flex-1 min-w-[300px]">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm"></i>
              <input
                type="text"
                placeholder="材料データを検索..."
                className="w-full pl-10 pr-4 py-2 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent"
              />
            </div>
            <div className="flex items-center gap-2 overflow-x-auto">
              {categories.map((cat) => (
                <button
                  key={cat}
                  onClick={() => setSelectedCategory(cat)}
                  className={`px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                    selectedCategory === cat
                      ? 'bg-teal-500 text-white'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  {cat === 'all' ? 'すべて' : cat}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50/80 border-b border-gray-200/80">
              <tr>
                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
                  <input type="checkbox" className="rounded border-gray-300 cursor-pointer" />
                </th>
                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">名称</th>
                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">カテゴリ</th>
                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">3Dモデル数</th>
                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">サイズ</th>
                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">更新日</th>
                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">ステータス</th>
                <th className="px-6 py-4 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">操作</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200/80">
              {filteredMaterials.map((material) => (
                <tr key={material.id} className="hover:bg-gray-50/50 transition-colors">
                  <td className="px-6 py-4">
                    <input type="checkbox" className="rounded border-gray-300 cursor-pointer" />
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 bg-gradient-to-br from-teal-400 to-teal-600 rounded-lg flex items-center justify-center">
                        <i className="ri-box-3-fill text-white text-lg"></i>
                      </div>
                      <span className="font-medium text-gray-900">{material.name}</span>
                    </div>
                  </td>
                  <td className="px-6 py-4">
                    <span className="px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-xs font-medium">
                      {material.category}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-sm text-gray-600">{material.models}個</td>
                  <td className="px-6 py-4 text-sm text-gray-600">{material.size}</td>
                  <td className="px-6 py-4 text-sm text-gray-600">{material.date}</td>
                  <td className="px-6 py-4">
                    {material.status === 'active' ? (
                      <span className="px-3 py-1 bg-green-100 text-green-700 rounded-full text-xs font-medium">
                        アクティブ
                      </span>
                    ) : (
                      <span className="px-3 py-1 bg-yellow-100 text-yellow-700 rounded-full text-xs font-medium">
                        処理中
                      </span>
                    )}
                  </td>
                  <td className="px-6 py-4">
                    <div className="flex items-center gap-2">
                      <button className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 transition-colors cursor-pointer">
                        <i className="ri-eye-line text-gray-600"></i>
                      </button>
                      <button className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 transition-colors cursor-pointer">
                        <i className="ri-edit-line text-gray-600"></i>
                      </button>
                      <button className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 transition-colors cursor-pointer">
                        <i className="ri-download-line text-gray-600"></i>
                      </button>
                      <button className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-red-50 transition-colors cursor-pointer">
                        <i className="ri-delete-bin-line text-red-600"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="px-6 py-4 border-t border-gray-200/80 flex items-center justify-between">
          <p className="text-sm text-gray-600">
            {filteredMaterials.length}件中 1-{filteredMaterials.length}件を表示
          </p>
          <div className="flex items-center gap-2">
            <button className="px-4 py-2 border border-gray-200 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap">
              前へ
            </button>
            <button className="px-4 py-2 bg-teal-500 text-white rounded-lg text-sm font-medium cursor-pointer whitespace-nowrap">
              1
            </button>
            <button className="px-4 py-2 border border-gray-200 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap">
              次へ
            </button>
          </div>
        </div>
      </div>

      {showUploadModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl max-w-2xl w-full p-8">
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-xl font-bold text-gray-900">新規材料データアップロード</h3>
              <button
                onClick={() => setShowUploadModal(false)}
                className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100 transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-xl text-gray-600"></i>
              </button>
            </div>

            <div className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">材料名</label>
                <input
                  type="text"
                  placeholder="例: 石材パケット_大理石_001"
                  className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">カテゴリ</label>
                <select className="w-full px-4 py-2 pr-8 border border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm cursor-pointer">
                  <option>石材</option>
                  <option>タイル</option>
                  <option>木材</option>
                  <option>金属</option>
                  <option>ガラス</option>
                  <option>コンクリート</option>
                  <option>壁紙</option>
                  <option>カーペット</option>
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">ファイルアップロード</label>
                <div className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center hover:border-teal-500 transition-colors cursor-pointer">
                  <i className="ri-upload-cloud-2-line text-4xl text-gray-400 mb-3"></i>
                  <p className="text-sm text-gray-600 mb-1">クリックまたはドラッグ&ドロップでファイルをアップロード</p>
                  <p className="text-xs text-gray-500">対応形式: ZIP, GLB, GLTF, FBX (最大500MB)</p>
                </div>
              </div>

              <div className="flex items-center gap-3 pt-4">
                <button
                  onClick={() => setShowUploadModal(false)}
                  className="flex-1 px-6 py-3 border border-gray-200 text-gray-700 rounded-lg font-medium hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap"
                >
                  キャンセル
                </button>
                <button className="flex-1 px-6 py-3 bg-teal-500 text-white rounded-lg font-medium hover:bg-teal-600 transition-colors cursor-pointer whitespace-nowrap">
                  アップロード
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
